import * as React from "react";
import "../../assets/scss/loader.scss";

export default function Loader() {
  return (
    <div className="loader-container">
            <div className="loading-fg"></div>
    </div>
  );
}